import http from '@ess-v3/utils/http'

const BASE_PATH = 'https://japi.233.com/ess-ucs-api'

export const getUserInfoApi = () => {
  const _path = `${BASE_PATH}/doz/members/userInfo`
  return http.getJ<UserInfoRes>(_path, null)
}

export interface UserInfoRes
  extends Partial<{
    /** 用户名 */
    userName: string
    /** 昵称 */
    nickName: string
    /** 性别,0=未知，1=男，2=女 */
    sex: number
    /** 生日 */
    birthday: string
    /** 省份城市 */
    location: string
    /** 真实姓名 */
    trueName: string
    /** 头像 */
    headPic: string
    /** 是否绑定手机 */
    bindTel: boolean
    /** 是否绑定QQ */
    bindQQ: boolean
    /** 是否绑定微信 */
    bindWX: boolean
    /** 是否绑定微博 */
    bindWB: boolean
    /** 微信用户的unionId */
    unionId: string
    // 是否购买课程
    buyCourse?: boolean
    /** 联盟登录信息 */
    unionSign: string
    [property: string]: any
  }> {
  /** 用户ID */
  userId: number
  /** 已绑定的手机号 */
  tel: string
}
